const LG_MEDIA_QUERY = '(min-width: 992px)';

function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

class EyebrowIllustrationScroll {
    constructor(block) {
        this.block = block;
        this.illustration = block.querySelector('.eyebrow-with-heading-ilustration');
        this.content = block.querySelector('.eyebrow-with-heading-content');

        if (!this.illustration || !this.content) return;

        this.enabled = false;
        this.ticking = false;

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onScroll.bind(this);
        this.update = this.update.bind(this);

        this.mediaQuery = window.matchMedia(LG_MEDIA_QUERY);
        this.mediaQueryHandler = () => this.syncEnabledState();

        this.mediaQuery.addEventListener('change', this.mediaQueryHandler);
        this.syncEnabledState();
        this.update();
    }

    syncEnabledState() {
        const shouldEnable = this.mediaQuery.matches;

        if (shouldEnable && !this.enabled) {
            this.enabled = true;
            this.block.classList.add('has-illustration-scroll');
            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onResize, { passive: true });
            this.update();
            return;
        }

        if (!shouldEnable && this.enabled) {
            this.enabled = false;
            this.block.classList.remove('has-illustration-scroll');
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onResize);
            this.illustration.style.removeProperty('transform');
        }
    }

    update() {
        this.ticking = false;

        if (!this.enabled) return;

        const contentRect = this.content.getBoundingClientRect();
        const viewHeight = window.innerHeight || 1;
        const travel = viewHeight + contentRect.height;

        if (travel <= 0) return;

        // 0 = content entering viewport, 1 = content leaving viewport.
        const progress = clamp((viewHeight - contentRect.top) / travel, 0, 1);

        // Sweep the apple down and to the right while scrolling.
        const yTravel = Math.max(contentRect.height * 0.95, 150);
        const xTravel = 130;
        const y = progress * yTravel;
        const x = progress * xTravel;

        this.illustration.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0)`;
    }

    onScroll() {
        if (!this.enabled || this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(this.update);
    }

    destroy() {
        this.mediaQuery.removeEventListener('change', this.mediaQueryHandler);

        if (this.enabled) {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onResize);
        }

        this.enabled = false;
        this.block.classList.remove('has-illustration-scroll');
        this.illustration.style.removeProperty('transform');
    }
}

let instances = [];

function initEyebrowIllustrations() {
    if (prefersReducedMotion()) return;

    instances.forEach((instance) => instance.destroy());
    instances = [];

    document.querySelectorAll('.block-eyebrow-with-heading--has-illustration').forEach((block) => {
        const instance = new EyebrowIllustrationScroll(block);
        if (instance.illustration) {
            instances.push(instance);
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEyebrowIllustrations);
} else {
    initEyebrowIllustrations();
}
